var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalenderForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.8748 9.93436C0.516486 9.57857 0.515463 8.99936 0.872518 8.6423L3.62036 5.89446C4.05601 5.45881 4.05601 4.75249 3.62036 4.31684L0.872518 1.569C0.515464 1.21194 0.516487 0.632729 0.874801 0.276938V0.276938C1.23133 -0.0770789 1.80703 -0.0760618 2.1623 0.279213L6.19993 4.31684C6.63558 4.75249 6.63558 5.45881 6.19993 5.89446L2.1623 9.93209C1.80703 10.2874 1.23133 10.2884 0.8748 9.93436V9.93436Z",
    fill: "#D2D2D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderForward);
export default __webpack_public_path__ + "static/media/calenderForward.9ea610a35868e5a1ef7e84866e035c88.svg";
export { ForwardRef as ReactComponent };